import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.types';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Filters.module.scss';
import { Select } from 'components/DesignSystem/Select';

export const Urgent = ({ options, onFiltersChanged, isLoading }) => {
    const { control } = useFormContext<IFields>();

    return (
        <div className={classes.selectWrapper}>
            <span className={classes.title}>Urgent</span>
            <Controller
                render={({ field }) => (
                    <Select<ISelectOption<string>>
                        id={'battlecards-filters-urgent'}
                        {...field}
                        options={options}
                        onChange={(newValue) => {
                            field.onChange(newValue);
                            onFiltersChanged({ [field.name]: newValue });
                        }}
                        isClearable={true}
                        isLoading={isLoading}
                    />
                )}
                name={`urgent`}
                control={control}
            />
        </div>
    );
};
